import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api, BACKEND } from "@/lib/api";
import { H, Tabs, Table } from "./ui";

const TIPOS = [["vendas", "Vendas"], ["produtos", "Produtos"], ["estoque", "Estoque"], ["clientes", "Clientes"], ["cupons", "Cupons"], ["utm", "ROI por UTM"], ["dre", "DRE simples"]];

export default function Reports() {
  const [tipo, setTipo] = useState("vendas");
  const [dias, setDias] = useState(30);
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/admin/reports/${tipo}`, { params: { dias } }).then((r) => setRows(r.data)); }, [tipo, dias]);
  const cols = rows[0] ? Object.keys(rows[0]).map((k) => [k, k]) : [["-", "Sem dados"]];
  return (
    <div data-testid="admin-reports">
      <H actions={<>
        <select aria-label="Período" className="input-na w-40 py-2" value={dias} onChange={(e) => setDias(Number(e.target.value))} data-testid="report-period">{[7, 30, 90, 365].map((d) => <option key={d} value={d}>Últimos {d} dias</option>)}</select>
        <a className="btn-line px-4 py-2" href={`${BACKEND}/api/admin/reports/${tipo}?dias=${dias}&formato=csv`} data-testid="report-csv"><Download className="h-4 w-4" /> Exportar CSV</a>
      </>}>Relatórios</H>
      <Tabs value={tipo} onChange={setTipo} tabs={TIPOS} />
      <Table rows={rows} cols={cols} testid={`report-${tipo}`} />
      {tipo === "dre" && <p className="mt-3 text-xs text-na-ink2">Taxas estimadas (Pix 0,99%, cartão/boleto 4,99%). Marketing vem de Configurações.</p>}
    </div>
  );
}
